import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardToolbarComponent } from './dashboard-toolbar.component';
import {DxSelectBoxModule, DxToolbarModule} from 'devextreme-angular';



@NgModule({
  declarations: [DashboardToolbarComponent],
  imports: [
    CommonModule,
    DxToolbarModule,
    DxSelectBoxModule
  ],
  exports: [DashboardToolbarComponent]
})
export class DashboardToolbarModule { }
